import StormwaterEntries from "../docs-archive-elements/StormwaterEntries";
export default function StormwaterDetails() {
    return (
      <div>
  <div className="stormwater-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
<h2>Stormwater Management</h2>
</div>

{/*Start Main Content*/}
<div className="content-fluid">

<div className="mb-960-center-container mid-side-outlines">
    {/*Full Width Element*/}
    <div className="mb-960-col-50p">
        <div className="left-right-padding-1em">
            <br/>
            <h4>General</h4>
            <p>
            As stormwater flows over driveways, lawns, and sidewalks, it picks up debris, chemicals, dirt, and other pollutants. Stormwater can flow into a storm sewer system or directly to a lake, stream, river, wetland, or coastal water. Anything that enters a storm sewer system is discharged untreated into the water bodies we use for swimming, fishing, and providing drinking water. Polluted runoff is the nation’s greatest threat to clean water. By practicing healthy household habits, homeowners can keep common pollutants like pesticides, pet waste, grass clippings, and automotive fluids off the ground and out of stormwater. Adopt these healthy household habits and help protect lakes, streams, rivers, wetlands, and coastal waters. Remember to share the habits with your neighbors!</p>
            <h4>Report Dumping</h4>
            Whenever illicit discharges or other pollution is observed to be affecting the storm water system, for example, if someone is seen dumping used oil into a stormwater inlet, etc., please call the pollution hotline numbers:
            <ul>
                <li>During business hours (8:00 a.m. – 4:30 p.m.) call<br/><a href="tel:2152958181"><i className="fa-solid fa-phone">
                        </i>&nbsp;215-295-8181</a></li>
                <li>After business hours call NON-EMERGENCY POLICE DISPATCH at<br/> <a href="tel:215958111"><i className="fa-solid fa-phone">
                        </i>&nbsp;215-295-8111</a></li>
                <li>If you are unable to reach someone at the above phone numbers, call the<br/>
                    PA DEP Southeast Regional Office<br/>
                    2 East Main Street<br/>
                    Norristown, PA 19401<br/>
                    <a href="tel:4842505900"><i className="fa-solid fa-phone"></i>&nbsp;484-250-5900</a>
                </li>
            </ul>

        </div>
    </div>

    <div className="mb-960-col-50p">
        <div className="left-right-padding-1em">
            <br/>
            <h4>Related Documents</h4>
          <StormwaterEntries />

        </div>
    </div>
</div>
</div>
<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>
</div>
      </div>
    )
}
